/* TAG - the record counter.
   Counts 0 -> 16 on first view, lights the frag feed in step, snaps on the
   last frag, then cross-fades career frames inside the glyphs.

   NOTE: this script must never touch the section's id or class list on the
   root - section CSS is scoped to #tagx-rec-<id>, and rewriting the id strips
   every style from the section (it collapses and the page jumps). Only the
   is-hit state class is added, which the scoped CSS expects. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build(root) {
    if (root.dataset.recOn) return;
    root.dataset.recOn = '1';

    var num = root.querySelector('[data-count]');
    if (!num) return;
    var target = parseInt(num.dataset.count, 10) || 16;
    var texts = [].slice.call(num.querySelectorAll('.tagx-numfill__edge, .tagx-numfill__frame'));
    var notches = [].slice.call(root.querySelectorAll('.tagx-rec__notch'));
    var frames = [].slice.call(num.querySelectorAll('.tagx-numfill__frame'));

    function paint(v) {
      var s = String(v);
      texts.forEach(function (t) { t.textContent = s; });
      num.dataset.num = s;
      for (var i = 0; i < notches.length; i++) notches[i].classList.toggle('is-lit', i < v);
    }

    if (frames.length) frames[0].classList.add('is-on');
    if (reduce) { paint(target); return; }
    paint(0);

    var fi = 0;
    function cycle() {
      if (frames.length < 2) return;
      frames[fi].classList.remove('is-on');
      fi = (fi + 1) % frames.length;
      frames[fi].classList.add('is-on');
      num.classList.add('is-tear');
      setTimeout(function () { num.classList.remove('is-tear'); }, 170);
    }

    var ran = false;
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting || ran) return;
      ran = true;
      io.disconnect();
      var t0 = performance.now(), dur = 1700;
      (function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        var v = Math.round((1 - Math.pow(1 - p, 4)) * target);
        paint(v);
        if (p < 1) requestAnimationFrame(step);
        else { root.classList.add('is-hit'); setInterval(cycle, 2200); }
      })(t0);
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.2 });
    io.observe(root);
  }

  function init() { document.querySelectorAll('[data-record]').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
